var _path, _ellipse, _path2, _ellipse2, _path3, _ellipse3, _path4, _ellipse4, _path5, _ellipse5, _path6, _ellipse6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval64ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M50 17c7.18 0 13 5.82 13 13s-5.82 13-13 13H30c-7.18 0-13-5.82-13-13s5.82-13 13-13h20Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28,
  cy: 8,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 28 8)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M22 9V8c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 52,
  cy: 8,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 52 8)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M46 9V8c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 72,
  cy: 30,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-180 72 30)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M71 24h1c2.761 0 5 2.686 5 6s-2.239 6-5 6h-1"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8,
  cy: 30,
  fill: "#464D57",
  rx: 5,
  ry: 6
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M9 36H8c-2.761 0-5-2.686-5-6s2.239-6 5-6h1"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28,
  cy: 52,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 28 52)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M34 51v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 52,
  cy: 52,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 52 52)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M58 51v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})));
SvgOval64ASelected.viewBox = '0 0 80 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval64ASelected);
export default ForwardRef;